var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center-container"},[_c('section',{staticClass:"map-content"},[(_vm.address !== '-')?_c('map-container'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }